import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/500.css';
import '@fontsource/manrope/600.css';

import App from './App';
import { CustomizerContextProvider } from './context/CustomizerContext';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import { ShoppingCartProvider } from './context/ShoppingCartContext';
import { ProductProvider } from './context/EcommerceContext';
import './i18n';
import './index.css';
import { ThemeSettings } from '@/theme/Theme.tsx';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

// Компонент-обгортка для теми
const AppWithTheme = () => {
  const theme = ThemeSettings();
  
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  );
};

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <AuthProvider>
      <CustomizerContextProvider>
        <NotificationProvider>
          <ShoppingCartProvider>
            <ProductProvider>
              <QueryClientProvider client={queryClient}>
                <AppWithTheme />
                <ReactQueryDevtools initialIsOpen={false} />
              </QueryClientProvider>
            </ProductProvider>
          </ShoppingCartProvider>
        </NotificationProvider>
      </CustomizerContextProvider>
    </AuthProvider>
  </React.StrictMode>,
);
